import {IClaim} from '../Models/ClaimModel'; 
import {checkWindowFunction,checkWindowFunctionWithArgs} from '../Models/CommonItemsModel'; 
import { NoTzDate} from "../../lib/DateUtils";
export enum InstallmentType {
    Weekly = 1,
    Monthly = 2,
    BiWeekly = 3,
}
export enum RecurringClassLabel {
    Enabled = "ps-1 pe-3",
    Disabled = "ps-1 pe-3 text-muted"
}
export enum PlanSettingItem {
    MinPlanAmount = 1,
    MaxPlanAmount = 2,
    MinInstallmentMonths = 3,
    MaxInstallmentMonths = 4, 
    RecurringPayments = 5,
    LastPaymentMin = 6
}
export enum PlanStatus {
    Active = 1,
    Completed = 2,
    PastDue = 3,
    Hold = 98,
    Cancelled = 99
}
export interface IPatientPaymentPlanMessage { 
    activeMessage: string,
    pastDueMessage: string,
    holdMessage: string,
    cancelledMessage: string,
    completedMessage: string
}
export interface IPatientNameDob {
    patientName: string,
    patientDOB?: string,
    patientRHC?: string,
    responsiblePartyEID? : number
}
export interface IPatientPaymentPlan {
    paymentPlanID: number,
    statusDescription: string, 
    totalAmount: number, 
    remainingTotal: number, 
    installmentAmount: number, 
    startDate: NoTzDate,
    endDate: NoTzDate,
    dueDate: NoTzDate,
    comment?: string
}      
export interface IDeferDate {
    deferDate: NoTzDate
}
export interface IDeferPlan {
    paymentPlanId: number,
    deferDate: NoTzDate,
    numberOfPeriods: number
}
export interface IPlanSetup {
    patientInformation: IPatientNameDob,
    patientPlans: IPatientPaymentPlan[],
    patientClaims: IClaim[]
};    
   
export interface IPaymentPlanDate {
    PaymentPlanID: number,
    StartDate: NoTzDate,
    NewDate: NoTzDate,
    InstallmentType: InstallmentType
}
export interface IPaymentPlanDetail {
    patientID: number,
    patientName: string, 
    patientDOB?: string,
    patientRHC?: string,
    createdBy?: string,
    responsiblePartyEID: number
    responsiblePartyName: string, 
    statusID: number, 
    statusDescription: string, 
    installmentType: number, 
    installmentTypeDescription: string,
    startDate: NoTzDate, 
    endDate: NoTzDate, 
    dueDate: NoTzDate, 
    initialTotalAmount: number,
    totalAmount: number, 
    totalPayments: number, 
    remainingTotal: number, 
    installmentAmount: number, 
    writeOffAdjustmentAmount: number, 
    totalInstallments: number,
    remainingInstallments: number,
    recurringPayments: boolean,
    cardOnFile: boolean,
    excludeClaimStatements: boolean,
    doNotSendStatement: boolean,
    comment: string, 
    paymentMethodID: number, 
    creditCard: string,
};     

export interface IPaymentPlanInstallment {
    installmentID: number,
    dueDate: NoTzDate, 
    installmentAmount: number, 
    paymentDates?: string, 
    paymentAmount?: number
};      
export interface IPlanSummary {
    installmentID: number,
    installmentDate: NoTzDate, 
    installmentAmount: number
};  
export interface IInstallmentDisplay {
    InstallmentType: InstallmentType,
    PlanTotal: number, 
    InstallmentStartDate: NoTzDate,
    InstallmentAmount: number, 
    NumberInstallments: number
};  
export interface IPaymentPlanDeferments {
    defermentInformation: string
};
export interface IPaymentPlanDetails {
    planDetail: IPaymentPlanDetail,
    installmentListing: IPaymentPlanInstallment[],
    planClaims?: IClaim[],
    patientClaims?: IClaim[],
    paidClaims?: IClaim[],
    deferments?: IPaymentPlanDeferments[]
};
      
export interface IPaymentPlanUpdate {
    paymentPlanId: number,
    totalAmount: number, 
    writeOffAdjustmentAmount: number,   
    installmentAmount: number, 
    totalInstallments: number,
    comment?: string, 
    recurringPayments: boolean,
    excludeClaimStatements: boolean,
    doNotSendStatement: boolean
};
export interface IPaymentPlanCardUpdate {
    paymentPlanId: number,
    paymentMethodID?: number,
    creditCard?: string,
};
export interface IPaymentPlanStatusUpdate {
    paymentPlanId: number,
    statusID: number,
    removeClaims: boolean
}
export interface IPaymentPlanCreate {
    patientId: number,
    responsiblePartyEID: number,
    paymentMethodId?: number,
    totalAmount: number, 
    writeOffAdjustmentAmount: number, 
    installmentType: number, 
    installmentStartDate: NoTzDate,  
    installmentAmount: number, 
    numberInstallments: number,
    comment?: string, 
    recurringPayments: boolean,
    excludeClaimsFromStatements: boolean,
    doNotSendStatement: boolean,
    claimList: IClaim[]
};
 
export interface IPaymentClaimInformation {
    addClaim: boolean, 
    canAdjustTotal: boolean,
    adjustTotal: boolean,
    claimList: string,
    adjustmentAmount: number
}
export interface IPaymentPlanClaimUpdates {
    paymentPlanId: number, 
    addClaims: boolean, 
    totalAdjustmentAmount: number,  
    claimList: IClaim[]
}
export interface IRespPartyUpdate {
    paymentPlanId: number, 
    responsiblePartyEID: number
}
export interface IPaymentReportInputs {
    errorFlag: boolean, 
    startDate: NoTzDate,
    endDate: NoTzDate
}
export interface IPaymentPlanPayReport {
    recordKey: number, 
    paymentPlanID: number, 
    totalAmount: number, 
    installmentAmount: number, 
    statusDescription: string, 
    patientID: number, 
    patientName: string, 
    paymentAmount: number, 
    paymentDate: NoTzDate, 
    localTime: string, 
    errorFlag: boolean, 
    paymentMessage: string, 
    paymentDetails: string
}
export interface ICompanyInformation {
    companyProfileName: string,
    streetAddress1: string,
    streetAddress2?: string,
    cityStateZip: string,
    phoneNumber: string,
}
export interface IPatientPlanDetails {
    patientName: string,
    totalAmount: number,
    totalPayments: number,
    totalInstallments: number,
    remainingTotal: number,
    remainingInstallments: number,
    statusDescription: string,
    statusIssue: boolean,
    installmentDueDate: NoTzDate}

export interface IPatientInstallmentDetails {
    installmentNumber: number,
    dueDate: NoTzDate,
    installmentAmount: number,
    paymentAmount: number 
}
export interface IPrintPlanDetails {
    companyData: ICompanyInformation,
    patientData: IPatientPlanDetails,
    installmentDetails: IPatientInstallmentDetails[]
}
export const PlanMaximumAmount: number = 99999.99;
export const PlanMaximumCount: number = 99;

export function UpdateTitleBar(patientID: number, patientName: string, patientDOB: string, patientRHC: string) {
    const title_function = checkWindowFunctionWithArgs<() => void>('SetPaymentPlanTitle',false);
    if (title_function) { 
        title_function(patientID,patientName,patientDOB,patientRHC);
    }
}
export function closeVueModal() { 
    const close_function = checkWindowFunction<() => void>('CloseVueModalIframe',true);
    if (close_function) { 
        close_function();
    }
}
